import { DateTime } from 'luxon';

export class DateUtils {
    static fromISO(isoString: string, format = 'dd-MMM-yyyy'): string {
        return DateTime.fromISO(isoString).toFormat(format);
    }

    static parseFormatted(dateString: string, format = 'dd MMM yyyy hh:mm a'): DateTime {
        return DateTime.fromFormat(dateString, format);
    }
}
